export const PERMS = {
    READ: 'here_map.read',
}
